import {html, LitElement, nothing, PropertyValues, unsafeCSS} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import {ifDefined} from 'lit/directives/if-defined.js';
import {GradingSystem, Route, RouteMeta, Vote} from "../_types";

import './theme.css';

// @ts-ignore
import styles from './routes.css?inline'
import {getGradeDisplay} from "../lib/grading-system";
import {getMetaLabel} from "../lib/meta";
import './route'
import {EventRouteExpandToggle, EventRouteVote} from "./events";
import ClimbPressRoute from "./route";

@customElement("climbpress-routes")
export default class ClimbPressRoutes extends LitElement {
    static styles = unsafeCSS(styles);

    @property({type: Object})
    public i18n: { [key: string]: string } = {}

    @property({attribute: "grading-systems", type: Object})
    public gradingSystems: GradingSystem[] = [];

    @property({type: Array})
    public routes: Route[] = [];

    @property({type: Object})
    public votes: {[route: number]: Vote|undefined} = {}

    @property({attribute: "route-meta-structure", type: Array})
    public routeMetaStructure: RouteMeta[] = [];

    @property({attribute: "route-meta-collapsed", type: Array})
    public routeMetaCollapsed?: string[]

    @property({type: Number})
    public count: number = 10;

    @property({attribute: "hide-search", type: Boolean})
    public hideSearch: boolean = false;

    @property({attribute: "hide-filters", type: Boolean})
    public hideFilters: boolean = false;

    @property({attribute: "show-voting", type: Boolean})
    public showVoting: boolean = false;

    @state()
    private searchQuery: string = "";

    @state()
    private active: number[] = []

    @state()
    private filterBy: { [key: string]: string } = {};

    getById(route: number): null | ClimbPressRoute{
        let needle: null|ClimbPressRoute = null;
        this.shadowRoot?.querySelectorAll("climbpress-route").forEach(element=> {
            if(element.route != null && element.route.id == route){
                needle = element;
            }
        })
        return needle;
    }

    // ------------------------------------------------------------
    // render
    // ------------------------------------------------------------
    protected render() {
        const filtered = this.getFilteredRoutes();
        const cutOffRoutes = this.cutOffRoutes(filtered);

        return html`
            <div class="container">
                ${this.renderSearch()}
                ${this.renderFilters()}
                <div class="routes">
                    ${cutOffRoutes.length > 0 ?
                            cutOffRoutes.map(this.renderRoute.bind(this))
                            :
                            html`<slot name="not-found"><p><i>No route found</i></p></slot>`
                    }
                </div>

                ${cutOffRoutes.length < filtered.length ?
                        html`
                            <slot name="button" @click=${this.onClickAll}>
                                <button role="button">All routes</button>
                            </slot>`
                        : nothing
                }
            </div>
        `;
    }

    private renderRoute(route: Route) {
        const isExpanded = this.active.includes(route.id);

        const onToggle = (e: CustomEvent<EventRouteExpandToggle>) => {
            if(this.active.includes(e.detail.route)){
                this.active = this.active.filter(el => el != e.detail.route);
            } else {
                this.active = [...this.active, e.detail.route];
            }
        }

        const onVote = (e: CustomEvent<EventRouteVote>)=> {
            console.debug(e.detail);
        }

        return html`
            <climbpress-route
                    @climbpressRouteExpandToggle=${onToggle}
                    @climbpressRouteVote=${onVote}
                    route=${JSON.stringify(route)}
                    meta-structure=${JSON.stringify(this.routeMetaStructure)}
                    meta-collapsed=${JSON.stringify(this.routeMetaCollapsed)}
                    grading-systems=${JSON.stringify(this.gradingSystems)}
                    ?expanded=${isExpanded}
                    vote=${ifDefined(this.votes[route.id] ? JSON.stringify(this.votes[route.id]) : undefined)}
            ></climbpress-route>
        `
    }

    private renderFilters() {
        return '';
        // if (this.hideFilters) return '';
        //
        // const systems = Array.from(
        //     new Set(this.routes.map(r => r.gradingSystem).filter(s => s != ""))
        // ).map(s => {
        //     return getGradingSystems().find(system => s == system.id)
        // }).filter(s => s != undefined);
        // const walls = Array.from(new Set(this.routes.map(r => r.sector).filter(w => w != "")));
        //
        // const labelGradingSystem = this.labels?.filterAllGradingSystems ?? "- All grading systems -";
        // const labelWall = this.labels?.filterAllWalls ?? "- All walls -"
        //
        // return html`
        //     <div class="filters">
        //         <select name="gradingSystem">
        //             <option value="">${labelGradingSystem}</option>
        //             ${systems.map(system => {
        //                 return html`
        //                     <option value=${system.id}>${system.name}</option>
        //                 `
        //             })}
        //         </select>
        //         <select name="wall">
        //             <option value="">${labelWall}</option>
        //             ${walls.map(w => {
        //                 return html`
        //                     <option value=${w}>${w}</option>`
        //             })}
        //         </select>
        //     </div>
        // `
    }

    private renderSearch() {
        if (this.hideSearch) return '';
        const label = this.i18n?.searchPlaceholder ?? "Search...";
        return html`
            <slot name="input"><input placeholder=${label} name="search"/></slot>
        `
    }

    // ------------------------------------------------------------
    // lifecycle
    // ------------------------------------------------------------
    protected firstUpdated(_changedProperties: PropertyValues) {
        super.firstUpdated(_changedProperties);

        this.renderRoot.addEventListener("keyup", (e) => {
            const target = (e.target as HTMLInputElement)
            if (target.name == "search") {
                this.searchQuery = target.value;
            }
        })

        this.renderRoot.addEventListener("change", (e) => {
            const target = (e.target as HTMLSelectElement);
            this.filterBy[target.name] = target.value;
            this.requestUpdate()
        })
    }

    // ------------------------------------------------------------
    // utils
    // ------------------------------------------------------------
    private searchAbleProps: Array<keyof Route> = ["name", "metas", "gradingSystem"];

    private cutOffRoutes(routes: Route[]) {

        if (this.count < 1) return routes;

        return routes.slice(0, this.count);
    }

    private getFilteredRoutes() {
        const searchValue = this.searchQuery.toLowerCase();
        return this.routes.filter(route => {
            const grade = getGradeDisplay(route, this.gradingSystems)
            if (grade.includes(searchValue)) {
                return true;
            }
            const doesNotMatch = Object.keys(this.filterBy).find((key) => {
                const routeValue = route[key as keyof Route]
                return this.filterBy[key] != "" && route.hasOwnProperty(key) && routeValue != this.filterBy[key];
            });
            if (doesNotMatch) return false;
            if (searchValue == "") {
                return true;
            }
            return this.searchAbleProps.find(prop => {
                if (prop == "metas") {
                    const value = route[prop];
                    return Object.keys(value).find(metaKey => {
                        const metaValue = value[metaKey];
                        const label = getMetaLabel(metaKey, metaValue, this.routeMetaStructure);
                        if (label) {
                            return label.toLowerCase().includes(searchValue.toLowerCase());
                        }
                        return metaValue.toLowerCase().includes(searchValue.toLowerCase());
                    }) != undefined;
                }
                const value = route[prop];
                return typeof value === "string" && value.toLowerCase().includes(searchValue.toLowerCase())
            }) != undefined;
        });
    }

    // ------------------------------------------------------------
    // event handling
    // ------------------------------------------------------------
    private handleClick(index: number) {
        if (this.active.includes(index)) {
            this.active = this.active.filter(i => i != index);
        } else {
            this.active = [
                ...this.active,
                index,
            ];
        }
    }

    private onClickAll() {
        this.count = 0;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'climbpress-routes': ClimbPressRoutes
    }
}
